// extracted by mini-css-extract-plugin
export default {"container":"TUR5eX91TF6TbrGX1TRt","separator":"ay70LqHRg2vW4vtXHLiX","crumb":"p0rK88rw5r1F55E_T8mH","crumbLink":"zcaXmI0GKO1baWQllQtg","crumbText":"K1xWfeEJ9GYh7ec4cev3"};